import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={26}
    height={18}
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7837 15.6193L17.511 10.125L13.0306 13.5098C12.9331 13.5876 12.7926 13.5916 12.6873 13.5137L8.20297 10.125L0.934296 15.6194C0.969412 15.8612 1.08261 16.0796 1.24622 16.2432H1.25015C1.453 16.4461 1.73373 16.5708 2.04175 16.5708H23.6725C23.9805 16.5708 24.2613 16.4461 24.4641 16.2432C24.6316 16.0796 24.7448 15.8613 24.7839 15.6194L24.7837 15.6193ZM17.3397 9.54797L12.8591 12.9366L8.37854 9.55189L8.36697 9.54404L0.918999 3.91312V2.51709C0.918999 2.20496 1.04377 1.92421 1.25035 1.72156C1.4532 1.51871 1.73394 1.39002 2.04196 1.39002H23.6727C23.9807 1.39002 24.2615 1.51479 24.4643 1.72156C24.6709 1.92422 24.7957 2.20495 24.7957 2.51709V3.91312L17.3477 9.54404L17.3397 9.54797ZM17.9751 9.77025L24.7953 4.61492V14.9251L17.9751 9.77025ZM0.919124 4.61492L7.73932 9.77025L0.919124 14.9251V4.61492ZM2.04204 0.828613H23.6728C24.1368 0.828613 24.558 1.01969 24.8621 1.32378H24.866C25.1701 1.62805 25.3574 2.053 25.3574 2.51716V15.4479C25.3574 15.9119 25.1701 16.3331 24.866 16.6411C24.558 16.9452 24.1368 17.1362 23.6728 17.1362H2.04205C1.582 17.1362 1.1608 16.9452 0.856704 16.6411H0.85278C0.544776 16.3331 0.357422 15.9119 0.357422 15.4479V2.51716C0.357422 2.04907 0.544776 1.62807 0.85278 1.32378C1.15686 1.01969 1.57804 0.828613 2.04204 0.828613Z"
      fill={color}
      stroke={color}
      strokeWidth={0.5}
    />
  </svg>
);
export default SVGComponent;